import React from "react";
import useAuth from "../../hooks/useAuth";
import { useGetAllTeamsQuery } from "../../redux/features/teams/teamsApi";
import TeamLoader from "../ui/TeamLoader";
import SingleTeam from "./SingleTeam";
import { ToastContainer, toast } from "react-toastify";
function TeamList() {
  const notify = (msg, type) => toast[type](msg);
  const { user } = useAuth();
  const {
    data: teams,
    isLoading,
    isError,
    isSuccess,
    error,
  } = useGetAllTeamsQuery({ email: user.email });

  React.useEffect(() => {
    if (isError && !isLoading) {
      notify(error.error, "error");
    }
    if (!isError && !isLoading && teams?.length === 0) {
      notify("No team to show", "warn");
    }
  }, [isError, isLoading, teams]);

  let content;
  if (!isError && isLoading) content = <TeamLoader />;
  if (!isError && !isLoading && teams?.length > 0) {
    content = teams?.map((team) => (
      <SingleTeam key={team.id} team={team} notify={notify} />
    ));
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-10 mt-4 gap-6 overflow-auto">
      {content}
    </div>
  );
}

export default TeamList;
